module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/districtwise-vacant-property/districtwise-vacant-property.component.css
// module id = ./src/app/reports/districtwise-vacant-property/districtwise-vacant-property.component.css
// module chunks = main